module.exports = __webpack_public_path__ + "media/images/main-bg-p-3200-130f4b1ce10457cb46c2deaad111d439.jpeg";